<template>
  <header class="page-header" v-show="!isBoardPage">
    <div class="breadcrumb-scroll-container" ref="scrollContainer">
      <el-breadcrumb separator="/" class="historical-breadcrumb">
        <transition-group
          name="breadcrumb-fade"
          tag="span"
          class="breadcrumb-group"
        >
          <el-breadcrumb-item
            v-for="(view, index) in visitedViews"
            :key="view.name"
            :class="{ 'is-active': isActive(view) }"
          >
            <router-link :to="view.path" class="breadcrumb-link">
              {{ view.title }}
            </router-link>
            <i
              v-if="visitedViews.length > 1"
              class="el-icon-close close-btn"
              @click.stop.prevent="closeView(view)"
            ></i>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb>
    </div>

    <el-popover
      placement="bottom"
      width="150"
      trigger="click"
      popper-class="user-info-popover"
    >
      <div class="user-info-dropmenu">
        <div class="menu-item" @click="handleEdit">
          <span>修改密码</span>
          <i class="icon-edit"></i>
        </div>
        <div class="menu-item" @click="logoutDialogShow = true">
          <span>退出登录</span>
          <i class="icon-logout"></i>
        </div>
      </div>

      <div class="user-info" slot="reference">
        <p>{{ crmUserMobile }}</p>
        <el-button icon="el-icon-arrow-down"></el-button>
      </div>
    </el-popover>

    <el-dialog
      title="提示"
      :visible.sync="logoutDialogShow"
      width="400px"
      append-to-body
    >
      <p>确定退出登录？</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logoutDialogShow = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="logoutOnline"
          :loading="logoutLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </header>
</template>

<script>
import { logout } from "@/common/api";

export default {
  name: "PageHeader",
  data() {
    return {
      crmUserMobile: localStorage.getItem("crmUserMobile"),
      logoutDialogShow: false,
      logoutLoading: false,
      visitedViews: [], // 存储访问过的历史页面
    };
  },
  computed: {
    parentTitle() {
      return this.$route.meta && this.$route.meta.parent
        ? this.$route.meta.parent
        : "";
    },
    pageTitle() {
      return this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : "";
    },
    isBoardPage() {
      return this.$route.path && this.$route.path.startsWith("/board");
    },
  },
  watch: {
    $route: {
      handler(to) {
        this.crmUserMobile = localStorage.getItem("crmUserMobile");
        this.addView(to);
        this.scrollToActive();
      },
    },
  },
  created() {
    this.initViews();
  },
  mounted() {
    this.initWheelScroll();
  },
  beforeDestroy() {
    this.destroyWheelScroll();
  },
  methods: {
    initViews() {
      const views = sessionStorage.getItem("visitedViews");
      if (views) {
        this.visitedViews = JSON.parse(views);
      }
      this.addView(this.$route);
    },
    addView(route) {
      if (!route.meta || !route.meta.title) return;
      if (["登录", "授权登录"].includes(route.name)) return;
      if (route.path && route.path.startsWith("/board")) return;

      const title =
        route.query && route.query.id && route.meta.editTitle
          ? route.meta.editTitle
          : route.meta.title;

      const existing = this.visitedViews.find((v) => v.name === route.name);
      if (existing) {
        // 如果存在同名路由（如不同 ID 的编辑页面），更新其 path 和 title 为最新一次点击的状态
        existing.path = route.fullPath;
        existing.title = title;
      } else {
        // 否则，作为全新足迹页面推入
        this.visitedViews.push({
          title,
          path: route.fullPath,
          name: route.name,
        });
      }
      this.saveViews();
    },
    closeView(view) {
      const index = this.visitedViews.findIndex((v) => v.name === view.name);
      if (index === -1) return;

      this.visitedViews.splice(index, 1);
      this.saveViews();

      if (this.isActive(view)) {
        const nextView =
          this.visitedViews[index] || this.visitedViews[index - 1];
        if (nextView) {
          this.$router.push(nextView.path);
        }
      }
    },
    saveViews() {
      sessionStorage.setItem("visitedViews", JSON.stringify(this.visitedViews));
    },
    isActive(view) {
      return view.path === this.$route.fullPath;
    },
    scrollToActive() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          const activeEl = container.querySelector(".is-active");
          if (activeEl) {
            activeEl.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          }
        }
      });
    },
    initWheelScroll() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.addEventListener("wheel", this.handleWheelScroll, {
          passive: false,
        });
      }
    },
    destroyWheelScroll() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.removeEventListener("wheel", this.handleWheelScroll);
      }
    },
    handleWheelScroll(e) {
      const container = this.$refs.scrollContainer;
      if (container) {
        const scrollAmount = e.deltaY || e.deltaX;
        if (scrollAmount !== 0) {
          e.preventDefault();
          container.scrollLeft += scrollAmount;
        }
      }
    },
    handleEdit() {
      this.$router.push({ path: "/permission/personal/form" });
    },
    logoutOnline() {
      this.logoutLoading = true;
      logout()
        .then((res) => {
          if (res.code == 0) {
            this.logoutLoading = false;
            this.logoutDialogShow = false;
            localStorage.clear();
            sessionStorage.removeItem("visitedViews"); // 退出时清空足迹
            this.$message({ message: "退出登陆成功", type: "success" });
            this.$router.push({ path: "/login" });
          } else {
            this.logoutLoading = false;
            this.logoutDialogShow = false;
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.logoutLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb-scroll-container {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
  margin-right: 30px;
  padding: 5px 0;
  display: flex;
  align-items: center;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
}

.historical-breadcrumb {
  display: inline-flex;
  align-items: center;

  .breadcrumb-group {
    display: inline-flex;
    align-items: center;
  }
}

::v-deep .el-breadcrumb__item {
  float: none;
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  margin-right: 8px; /* 增加页签之间的间距 */

  .el-breadcrumb__separator {
    display: none; /* 彻底隐藏斜杠分隔符 */
  }

  .breadcrumb-link {
    font-weight: 400 !important;
    color: #606266 !important;
    transition: color 0.3s;
    cursor: pointer !important; /* 强制覆盖 Element 最后一项默认的 cursor: default */
    text-decoration: none;

    &:hover {
      color: #4d6cea !important;
    }
  }

  .close-btn {
    font-size: 10px;
    margin-left: 6px;
    color: #909399;
    border-radius: 50%;
    padding: 2px;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      background-color: #f4f4f5;
      color: #f56c6c;
      transform: rotate(90deg);
    }
  }

  &.is-active {
    background: rgba(77, 108, 234, 0.08); /* 柔和胶囊背景底色 */

    .breadcrumb-link {
      font-weight: 600 !important;
      color: #4d6cea !important;
    }

    .close-btn {
      color: #4d6cea;

      &:hover {
        background-color: rgba(77, 108, 234, 0.15);
        color: #f56c6c;
      }
    }
  }
}

/* 渐变过渡动画 */
.breadcrumb-fade-enter-active,
.breadcrumb-fade-leave-active {
  transition: all 0.3s ease;
}
.breadcrumb-fade-enter,
.breadcrumb-fade-leave-to {
  opacity: 0;
  transform: translateX(-15px);
}
</style>
